

window.tools = {
    toast: (title, message) => {
        toastr8.info({
            message: message,
            title: title,
            timeOut: window.toastTimer * 1000,
            iconClass: 'fa fa-info icon-info',
            imgClass: 'toast-logo',
            positionClass: "toast8-top-right logo"
        });
        return true;
    }
};

